export const LOGIN = "LOGIN";
export const REGISTER = "REGISTER";
export const LOAD_USER = "LOAD_USER";
export const LOGOUT = "LOGOUT";
